export class ApplicationMessageSource {
  static global: string = 'global';
}
